__turbopack_context__.v({
  "header": "relatedProducts-module-scss-module__qoZRBq__header",
  "productGrid": "relatedProducts-module-scss-module__qoZRBq__productGrid",
  "productLink": "relatedProducts-module-scss-module__qoZRBq__productLink",
  "relatedProductButtonWrapper": "relatedProducts-module-scss-module__qoZRBq__relatedProductButtonWrapper",
  "relatedProductExcerpts": "relatedProducts-module-scss-module__qoZRBq__relatedProductExcerpts",
  "relatedProductInner": "relatedProducts-module-scss-module__qoZRBq__relatedProductInner",
  "relatedProductWrapper": "relatedProducts-module-scss-module__qoZRBq__relatedProductWrapper",
  "relatedProductsWrapper": "relatedProducts-module-scss-module__qoZRBq__relatedProductsWrapper",
});
